import React from 'react'
import FilesForm from '../components/importers/FilesForm'
import UploadStore from '../context/upload_file_context'

const ImportersApp = ({ }) => {
  return (
    <UploadStore>
      <FilesForm />
    </UploadStore>
  )
}

ImportersApp.propTypes = {
}

export default ImportersApp
